<div class="modal-header">
  <h5 class="modal-title mb-0">Copy campaign</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('cancel')"></button>
</div>

<div class="modal-body">
  <app-sb-input-form
    mode="add"
    title="Copy campaign"
    submitLabel="Save"
    [showHeader]="false"
    [embedded]="true"
    (submitted)="saveProject()"
    (cancelled)="modal.dismiss('cancel')">
    @if (campaignForm) {
    <div class="form-wraper" [formGroup]="campaignForm">
      <div class="row">
        <div class="col-md-12 mb-3">
          <label class="form-label">Campaign name <span class="text-danger">*</span></label>
          <input
            class="form-control"
            placeholder="Campaign name"
            type="text"
            formControlName="name"
            ngbAutofocus
            [class.is-invalid]="submitted && f.name.errors"
          >
          @if (submitted && f.name.errors?.required) {
          <div class="invalid-feedback d-block">
            Campaign name is required
          </div>
          }
        </div>
        <div class="col-md-12 mb-3">
          <label class="form-label">Project <span class="text-danger">*</span></label>
          <app-auto-complete-select
            [hideLabel]="true"
            [isCreatable]="false"
            [onlyBottomBorder]="false"
            [placeholder]="'Select Project'"
            [selectOptions]="projects()"
            [labelKey] = "'title'"
            (searchValue)="handleSearchValue($event)"
            (optionSelected)="handleProjectSelection($event)"
            [(selectedValue)]="projectId"
          ></app-auto-complete-select>
          @if (submitted && f.project_id.errors?.required) {
          <div class="invalid-feedback d-block">
            Project is required
          </div>
          }
        </div>
        <div class="col-md-12 customize-email d-flex align-items-center">
          <input id="with_influencers" placeholder="" type="checkbox" formControlName="with_influencers">
          <label for="with_influencers" class="mb-0">Same influencer type and segment</label>
        </div>
      </div>
    </div>
    }
  </app-sb-input-form>
</div>
